module.exports = __webpack_public_path__ + "bitmap@3x.png?3ec7290573b75ee9f074dbdfb16b71b6";